import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hrjq689fae: FaireBrandEntity = {
  token: "b_hrjq689fae",
  type: "brand",
  name: "Tutti Délices - Distributed by Scents of Europe",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c147263e4f26b85f7dce9e5a2bd8c26afb4b920e4ac1e7cf3665cac01f89328.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/77960e976780eaec727da927cbcab055fc73da5d24939fef511054ded0a222ea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7c147263e4f26b85f7dce9e5a2bd8c26afb4b920e4ac1e7cf3665cac01f89328.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/77960e976780eaec727da927cbcab055fc73da5d24939fef511054ded0a222ea.jpeg",
  location: "Hollywood, FL, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 26,
  isInsider: true,
  description:
    "We are ALL BIG kids!\nTUTTI DELICES’S COLLECTION EVOKES NOSTALGIA OF OUR FAVORITE CHILDHOOD MEMORIES HIDDEN INSIDE 6 CUPCAKE INSPIRED PERFUME RECIPES !\n\nThe “retro” connotation sparks emotion and takes on a comforting, reassuring aspect, bringing us closer to true authenticity. It’s a trend that makes us feel good and adds meaning to our lives.\n\nTutti Delices, A SAFE BET !",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:16.014Z",
    importedBy: "entity-db-cli",
  },
};
